//#region types
import { FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { GenericFormSection } from "models/propTypes/genericFormProps";
import { SalaryDraftFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
//#endregion
//#region components
import { useSalaryService } from "serviceHooks";
//#endregion
import { DateHelper, FilterHelper, QueryStateHelper } from "utils/helpers";

function useSalaryDraftReportFilterDefinition() {
  const salaryService = useSalaryService();
  const apiToReportFilterFormatter = async (filter: WintSuperkollAPIModel.SalaryDraftFilter) => {
    const reportFilter: SalaryDraftFormTypes.SalaryFilter = {};

    FilterHelper.setDateRange(
      reportFilter,
      FormFieldConstants.SalaryDraft.SalaryFilter.YearMonth,
      filter.from !== undefined ? DateHelper.getDateFromYearMonth(filter.from) : undefined,
      filter.to !== undefined ? DateHelper.getDateFromYearMonth(filter.to) : undefined
    );

    if (filter.states !== undefined) {
      reportFilter.state = salaryService
        .getValidSalaryDraftStates()
        .map((state) => ({
          id: state,
          value: salaryService.getSalaryDraftStateText(state),
        }))
        .filter((s) => filter.states?.includes(s.id as number));
    }

    return reportFilter;
  };

  const filterFormFields: GenericFormSection<SalaryDraftFormTypes.SalaryFilter>[] = [
    {
      label: TranslationKeys.Common.Dates,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        yearMonth: {
          label: TranslationKeys.Common.Period,
          type: FormEnums.FormFieldType.MONTHRANGE,
        },
      },
    },
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        state: {
          label: TranslationKeys.Common.Status,
          type: FormEnums.FormFieldType.MULTIPLESELECTION,
          extraProps: {
            items: salaryService.getValidSalaryDraftStates().map((state) => ({
              id: state,
              value: salaryService.getSalaryDraftStateText(state),
            })),
          },
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<SalaryDraftFormTypes.SalaryFilter> = {
    yearMonth: QueryStateHelper.monthRangeQueryEncoder(FormFieldConstants.SalaryDraft.SalaryFilter.YearMonth),
    state: QueryStateHelper.selectionItemsQueryEncoder(
      FormFieldConstants.SalaryDraft.SalaryFilter.State,
      salaryService.getValidSalaryDraftStates().map((state) => ({
        id: state,
        value: salaryService.getSalaryDraftStateText(state),
      }))
    ),
  };

  return { filterFormFields, filterQueryStateHandler, apiToReportFilterFormatter };
}

export default useSalaryDraftReportFilterDefinition;
